import { lazy } from "react";

const BaseOption = lazy(() => import("@views/Student/StudyPlans/Choose"))
const AddOption = lazy(() => import("@views/LessonOption/AddOption"))
const ReExamOption = lazy(() => import("@views/LessonOption/Re-ExamOption"))
const KrOption = lazy(() => import("@views/LessonOption/Kr"))


const LessonOptionRoutes = [
    {
        path: 'base/',
        element: <BaseOption />
    },
    {
        path: 'add/',
        element: <AddOption />
    },
    {
        path: 're-exam/',
        element: <ReExamOption />
    },
    {
        path: 'kr/',
        element: <KrOption />
    }
]

export default LessonOptionRoutes